export default "__VITE_ASSET__CxJ8cONa__"